<template>
  <div
    class="withdrawal-widget__success"
    data-test-id="withdrawal-success"
  >
    <div class="withdrawal-widget__success-text">
      <p
        class="withdrawal-widget__success-title"
        data-test-id="withdrawal-success-title"
      >
        {{ i18n.withdraw_success() }}
      </p>
      <p
        class="withdrawal-widget__success-amount"
        data-test-id="withdrawal-success-amount"
      >
        {{ `${amount} ${selectedAsset}` }}
      </p>
    </div>
    <div class="withdrawal-widget__success-btns">
      <md-button
        class="btn md-primary"
        data-test-id="withdrawal-confirm-reset-btn"
        @click="$emit('resetWidget')"
      >
        {{ i18n.lbl_go_back() }}
      </md-button>
      <md-button
        to="/history/index/"
        data-test-id="withdrawal-confirm-history-btn"
        class="btn md-mint"
      >
        {{ i18n.lbl_view_history() }}
      </md-button>
    </div>
  </div>
</template>

<script>
  import { i18n } from '@js/i18n'

  export default {
    name: 'WithdrawalSuccess',
    props: {
      selectedAsset: { type: String, required: true },
      amount: { type: [String, Number], required: true }
    },
    emits: ['resetWidget'],
    data: _ => ({
      i18n
    })
  }
</script>

<style lang="scss" scoped>
.withdrawal-widget__success {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  height: calc(100% - 22.5px);

  &-text {
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    height: 100%;
    width: 100%;
    text-align: center;
  }

  &-title,
  &-amount {
    font-size: 18px;
    font-weight: 500;
  }

  &-btns {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: auto;
    width: 100%;

    .btn {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/app/dashboard/widgets/WithdrawalWidget/WithdrawalSuccess.vue